import { Button } from "@/lib/components/Button/Button";

type Props = {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function TransitionListItem({
  label,
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  return (
    <Button
      variant={isSelected ? "gradientBorder" : "outline"}
      size="sm"
      className="shrink-0 justify-start pl-4 font-medium"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {label}
    </Button>
  );
}
